const mapStateToProps = (state) => {
    const {
        ui: {
            selectedGeoObjArray,
            dateRangeCriteria,
            rangeStartDate,
            rangeEndDate,
        } = {},
        api: {
            geoMultiObjReportExcel,
        } = {},
        service: {
            Api: {
                getMultiGeoObjReportExcel,
            } = {}
        } = {}
    } = state;
    return {
        selectedGeoObjArray,
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
        getMultiGeoObjReportExcel,
        geoMultiObjReportExcel,
    }
}

export default mapStateToProps